import {UserRepository} from "@api/repositories/UserRepository";
import {Store} from "vuex";
import {UserProfile} from "@api/models/UserProfile";
import Axios from "axios";
import {prepareProfileFilter} from "@api/helpers/profileSearch";

export class UserProfilesService {
    cancelToken: any = null;
    include = ["id", "userId", "lastName", "firstName", "photoFileId", "company", "position", "groupIds"];

    constructor(
        private readonly eventId: string,
        private readonly groupFilters: any,
        private readonly usersRepository: UserRepository,
        private readonly store: Store<any>
    ) {
    }

    /**
     * Fetches online users by ids
     * @param ids
     */
    async fetchOnlineUsers(ids: number[]): Promise<UserProfile[]> {
        try {
            return await this.usersRepository.profiles({
                where: {
                    userId: {
                        $in: ids
                    }
                },
                include: this.include,
                skip: 0,
                take: -1
            });
        } catch (e) {
            this.store.dispatch('reportError', e);
        }
        return [];
    }

    async searchProfiles(searchStr: string, pageLimit: number, skip: number): Promise<UserProfile[]> {
        try {
            if (this.cancelToken) {
                this.cancelToken.cancel();
            }

            this.cancelToken = Axios.CancelToken.source();

            const where = prepareProfileFilter({
                searchStr: searchStr,
                additionalFields: [],
                excludingUsers: [],
                groupFilter: this.groupFilters,
                eventId: this.eventId
            }) || {};

            return await this.usersRepository.profiles({
                take: pageLimit,
                skip: skip,
                include: this.include,
                where
            });
        }
        catch (e) {
            this.store.dispatch('reportError', e);
        }
        return [];
    }
}